import './Loader.scss';

export const SimpleLoader = () => {
  return (
    <div className="loader-container">
      <div className="simple-loader"></div>
    </div>
  );
};
